import { WithStyles, withStyles } from "@material-ui/core";
import { push } from "connected-react-router";
import * as React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";

import Footer from "../../components/Footer/Footer";
import MenuNavBar from "../../components/MenuNavBar/MenuNavBar";
import PopinEditProfile from "../../components/PopinEditProfile/PopinEditProfile";
import PopinPasswordProfile from "../../components/PopinPasswordProfile/PopinPasswordProfile";
import TopToolbar from "../../components/TopToolbar/TopToolbar";
import { User } from "../../models/User.model";
import { changePassword, endSu, getAdvisorsStats, signOut, updateUser } from "../../store/actions";
import { RootState } from "../../types/RootState";
import { styles } from "./Page.style";

interface PageProps extends WithStyles<typeof styles> {
    user: User;
    popin?: any;
    cover?: any;
    isOnline: boolean;
    isLoading: boolean;
    isSu: boolean;
    isHome?: boolean;
    elementsToSyncCount: number;
    updateUser: typeof updateUser;
    signOut: typeof signOut;
    push: typeof push;
    endSu: typeof endSu;
    changePassword: typeof changePassword;
    getAdvisorsStats: typeof getAdvisorsStats;
}
interface PageState {
    openEditProfile: boolean;
    openPasswordProfile: boolean;
}

class Page extends React.Component<PageProps> {
    state: PageState = {
        openEditProfile: false,
        openPasswordProfile: false,
    };

    render() {
        return (
            <div className={this.props.classes.page}>
                <TopToolbar
                    isOnline={this.props.isOnline}
                    elementsToSyncCount={this.props.elementsToSyncCount}
                    showNewProposition={!this.props.isHome}
                    user={this.props.user}
                    isSu={this.props.isSu}
                    push={this.props.push}
                    showEditProfile={() => this.setState({ openEditProfile: true })}
                    showPasswordProfile={() => this.setState({ openPasswordProfile: true })}
                    onDisconnect={this.props.signOut}
                    onEndSu={this.props.endSu}
                />
                <MenuNavBar
                    push={this.props.push}
                    isLoading={this.props.isLoading}
                    user={this.props.user}
                    goToMyAdvisors={() => this._gotToMyAdvisors()}
                />
                {this.props.cover}
                <div className={this.props.classes.container}>{this.props.children}</div>
                {this.props.popin}
                <PopinEditProfile
                    user={this.props.user}
                    open={this.state.openEditProfile}
                    onSubmit={(user) => {
                        this.props.updateUser(user);
                        this.setState({ openEditProfile: false });
                    }}
                    onCancel={() => this.setState({ openEditProfile: false })}
                />
                <PopinPasswordProfile
                    open={this.state.openPasswordProfile}
                    onSubmit={(currentPassword?: string, newPassword?: string) => {
                        this.props.changePassword({ currentPassword, newPassword });
                        this.setState({ openPasswordProfile: false });
                    }}
                    onCancel={() => this.setState({ openPasswordProfile: false })}
                />
                <Footer />
            </div>
        );
    }

    private _gotToMyAdvisors() {
        this.props.getAdvisorsStats();
        this.props.push("/advisors");
    }
}

export const PageConnected = compose(
    withStyles(styles),
    connect(
        (state: RootState, ownProps: PageProps) => ({
            user: state.me.user,
            isSu: state.auth.isSu,
            isOnline: state.context.isOnline,
            isLoading: state.context.isLoading,
            elementsToSyncCount: state.me.userDataModificationsToSync ? state.me.userDataModificationsToSync.length : 0,
        }),
        { push, updateUser, signOut, changePassword, endSu, getAdvisorsStats }
    )
)(Page);



// WEBPACK FOOTER //
// ./src/pages/Page/Page.tsx